/**
 * Format currency values to have € symbol after the number
 * Transforms "€1.9" to "1.9€", "€0" to "0€", etc.
 * @param {string} value - The currency string to format
 * @returns {string} - Formatted string with € after the number
 */
export const formatFees = (value) => {
  if (!value) return value;
  
  // Convert to string if not already
  const str = String(value).trim();
  
  // If it starts with €, move it to the end
  if (str.startsWith('€')) {
    return str.slice(1).trim() + '€';
  }
  
  // If € is somewhere in the string but not at the end, restructure it
  if (str.includes('€') && !str.endsWith('€')) {
    // Handle cases like "From €0.005/share" -> "From 0.005€/share"
    return str.replace(/€(\d+(?:[.,]\d+)?)/g, '$1€');
  }
  
  return str;
};

/**
 * Format minimum deposit with € after the number
 * @param {number|string} value - The deposit value
 * @returns {string} - Formatted string like "0€" or "100€"
 */
export const formatDeposit = (value) => {
  const num = value ?? 0;
  return `${num}€`;
};
